// extracted by mini-css-extract-plugin
export default {"wrap":"Checkbox_wrap__DUy9O","title":"Checkbox_title__zvFt8"};